import React from 'react';
import KickImage from 'Reuseables/KickImage';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import './IronImage.css';

class IronImage extends React.Component {
  constructor(props) {
    super(props);
    this.ironImageHd = null;
  }

  componentDidMount() {
    const hdLoaderImg = new Image();

    hdLoaderImg.src = this.props.srcLoaded;

    hdLoaderImg.onload = () => {
      this.ironImageHd.setAttribute(
        'style',
        `background-image: url('${this.props.srcLoaded}')`
      );
      this.ironImageHd.classList.add('iron-image-fade-in');
    }
  };

  render() {
    return (
      <div className="iron-image-container">
        <a href={`${this.props.onNavigate}`}>
          <div 
            className="iron-image-loaded" 
            ref={imageLoadedElem => this.ironImageHd = imageLoadedElem}
          >
          </div>
        </a>
        <OnLoadDivWrapper>
          <OnLoadDiv />
        </OnLoadDivWrapper>
      </div>
    )
  }
}

IronImage.propTypes = {
  srcPreload:PropTypes.string,
  srcLoaded:PropTypes.string,
}

IronImage.defaultProps = {
  srcPreload: "",
  srcLoaded: "",
};

const OnLoadDivWrapper = styled.div`
  background: #fff;
  border-color: #e5e6e9 #dfe0e4 #d0d1d5;
  padding: 12px;
  top: -14px; 
  right: 0; 
  bottom: 0; 
  left: 0;
  display: block;
  margin: 0 auto;
  // min-height: 200px;
`;

const OnLoadDiv = styled.div`
  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: #f6f7f8;
  background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);
  background-size: 800px 104px;
  position: absolute;
  top: 0; right: 0; bottom: 0; left: 0;
  display: block;
`;

export default IronImage;
